export default __webpack_public_path__ + "static/media/printer.348c73ce.png";